module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img13.a9c7bbce.jpg";